import { MatrixClient } from 'matrix-js-sdk/src/client';
import { ClientEvent, SyncState } from 'matrix-js-sdk/src/matrix';
import { useEffect, useState } from 'react';

import { MatrixLoggingInStatusEnum } from './utils';

const useMatrixSyncState = (matrixClient: MatrixClient | null, matrixLoggingInStatus: MatrixLoggingInStatusEnum) => {
  const [syncState, setSyncState] = useState<SyncState | null>(null);
  // Tracks if the client has ever reached Prepared/Syncing since login finished.
  const [hasReachedSyncReadyState, setHasReachedSyncReadyState] = useState(false);

  useEffect(() => {
    if (!matrixClient || matrixLoggingInStatus !== MatrixLoggingInStatusEnum.FINISHED) {
      setSyncState(null);
      setHasReachedSyncReadyState(false);
      return;
    }

    const syncReadyStates = [SyncState.Prepared, SyncState.Syncing];
    const initialState = matrixClient.getSyncState();
    setSyncState(initialState);

    if (initialState && syncReadyStates.includes(initialState)) setHasReachedSyncReadyState(true);

    const onSync = (state: SyncState) => {
      setSyncState(state);
      if (syncReadyStates.includes(state)) setHasReachedSyncReadyState(true);
    };

    matrixClient.on(ClientEvent.Sync, onSync);

    return () => {
      matrixClient.off(ClientEvent.Sync, onSync);
    };
  }, [matrixClient, matrixLoggingInStatus]);

  return { syncState, hasReachedSyncReadyState };
};

export default useMatrixSyncState;
